import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavbarComp = _resolveComponent("NavbarComp")!
  const _component_FooterComp = _resolveComponent("FooterComp")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NavbarComp),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "form-container my-5" }, [
      _createElementVNode("h2", { class: "text-center text-uppercase fw-bold mb-4" }, "Get in Touch"),
      _createElementVNode("p", { class: "text-center text-muted mb-4" }, " Have questions or need assistance? Fill out the form below, and we’ll respond promptly. "),
      _createElementVNode("form", {
        action: "https://formspree.io/f/mvgowyar",
        method: "POST",
        class: "contact-form mx-auto bg-dark text-light p-5 rounded shadow"
      }, [
        _createElementVNode("div", { class: "mb-4" }, [
          _createElementVNode("label", {
            for: "name",
            class: "form-label"
          }, "Your Name"),
          _createElementVNode("input", {
            type: "text",
            id: "name",
            name: "name",
            class: "form-control",
            placeholder: "Enter your name",
            required: ""
          })
        ]),
        _createElementVNode("div", { class: "mb-4" }, [
          _createElementVNode("label", {
            for: "email",
            class: "form-label"
          }, "Your Email"),
          _createElementVNode("input", {
            type: "email",
            id: "email",
            name: "email",
            class: "form-control",
            placeholder: "Enter your email",
            required: ""
          })
        ]),
        _createElementVNode("div", { class: "mb-4" }, [
          _createElementVNode("label", {
            for: "service",
            class: "form-label"
          }, "Select a Service"),
          _createElementVNode("select", {
            id: "service",
            name: "service",
            class: "form-control",
            required: ""
          }, [
            _createElementVNode("option", {
              value: "",
              disabled: "",
              selected: ""
            }, "Choose a service"),
            _createElementVNode("option", { value: "armed-response" }, "Armed Response"),
            _createElementVNode("option", { value: "k9-handling" }, "K9 Handling"),
            _createElementVNode("option", { value: "residential-security" }, "Residential Security"),
            _createElementVNode("option", { value: "agricultural-security" }, "Agricultural Security"),
            _createElementVNode("option", { value: "industrial-security" }, "Industrial Security"),
            _createElementVNode("option", { value: "electric-fencing-installations" }, "Electric Fencing Installations"),
            _createElementVNode("option", { value: "alarm-monitoring-installations" }, "Alarm Monitoring Installations")
          ])
        ]),
        _createElementVNode("div", { class: "mb-4" }, [
          _createElementVNode("label", {
            for: "message",
            class: "form-label"
          }, "Message"),
          _createElementVNode("textarea", {
            id: "message",
            name: "message",
            class: "form-control",
            rows: "5",
            placeholder: "Write your message here",
            required: ""
          })
        ]),
        _createElementVNode("div", { class: "text-center" }, [
          _createElementVNode("button", {
            type: "submit",
            class: "box-button px-5 py-2 fw-bold text-uppercase"
          }, " Submit ")
        ])
      ])
    ], -1)),
    _createVNode(_component_FooterComp)
  ], 64))
}